import React, { useEffect, useRef, useState } from 'react';
import { Box, Link, Tooltip } from '@mui/material';

// Texte tronqué avec lien — affiche un Tooltip uniquement si le contenu déborde.
const TruncatedLinkCell = ({ text, linkUrl, fontSize = '0.72rem', fontWeight = 600, maxWidth }) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (el) setIsTruncated(el.scrollWidth > el.clientWidth);
  }, [text]);

  const content = (
    <Box
      ref={ref}
      sx={{
        width: maxWidth ? `${maxWidth}px` : '100%',
        fontSize,
        fontWeight,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      <Link
        href={linkUrl}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        color="inherit"
        sx={{ cursor: 'pointer', fontWeight: 'inherit' }}
      >
        {text}
      </Link>
    </Box>
  );

  return isTruncated ? <Tooltip title={text}>{content}</Tooltip> : content;
};

export default TruncatedLinkCell;
